import { Reducer } from 'redux';
import { SemaphoreTypes, SemaphoreState } from './types';

const INITIAL_STATE: SemaphoreState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<SemaphoreState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SemaphoreTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SemaphoreTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case SemaphoreTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
